<template>
	<div class="note">
		<transition name="fade-note" appear>
			<div class="note__wrap">
				<span class="note__title section-title">
					{{ data.noteTitle }}
					{{ data.noteLeaderName }}
				</span>
				<div class="note__info">
					<ul>
						<li class="note__info-inner" v-for="item in data.items" :key="item.id" :class="item.classItem">
							<span class="note__content note__content--label">{{ item.label }}</span>
							<span class="note__content note__content--input">{{ item.info }}</span>
						</li>
					</ul>
				</div>
			</div>
		</transition>
	</div>
</template>

<script>
import { mixin as onClickOutside } from 'vue-on-click-outside';

export default {
	props: {
		data: {
			type: Object,
			required: true
		}
	},
	data () {
		return {
		};
	},
	mixins: [onClickOutside]
};
</script>

<style lang="scss" scoped>
.note {
	position: absolute;
	left: -17px;
	z-index: 15;
	width: 476px;
	top: 47px;
	transition: $dur $ease;
	opacity: 0;
	visibility: hidden;

	@include mq($xl) {
		top: 25px;
	}

	@include mq($md) {
		top: 30px;
		width: auto;
		left: 50%;
		transform: translateX(-50%);
	}
}

.note__wrap {
    padding: 23px 21px 27px;
    width: 100%;
    background-color: $white;
    display: flex;
    flex-direction: column;
    box-shadow: 0 2px 4px rgba($black, .25);
    border-radius: 8px;
	max-height: 420px;
    overflow: auto;

	@include mq($xl) {
		padding: 20px;
	}

	&::-webkit-scrollbar {
		width: 12px;
		height: 12px;
	}

	&::-webkit-scrollbar-track {
		background: #eceeef;
	}

	&::-webkit-scrollbar-thumb {
		background-color: #42526e;
		border-radius: 20px;
		border: 1px solid #eceeef;
	}
	scrollbar-width: thin;
	scrollbar-color: #42526e #eceeef;
}

.note__title {
    margin-bottom: 20px;
    font-size: 20px;

    @include mq($md) {
        font-size: 18px;
        margin-bottom: 20px;
    }

    @include mq($md) {
        font-size: 16px;
    }

    @include mq($sm) {
        font-size: 15px;
    }
}

.note__info-inner {
	display: flex;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 11px;
    margin-bottom: 14px;

	@include mq($xl) {
		margin-bottom: 10px;
	}

	@include mq($md) {
		flex-direction: column;
		justify-content: flex-start;
		align-items: flex-start;
	}

	&:not(:last-of-type) {
		border-bottom: 1px solid rgba(94, 108, 132, 0.2);
	}
}

.note__content {
	font-family: $font-main;
	font-size: 14px;
	line-height: 20px;
	color: $fiord;

	@include mq($xl) {
		font-size: 13px;
	}
}

.note__content--label {
	opacity: 0.5;

	@include mq($md) {
		margin-bottom: 10px;
	}
}

.note__content--input {
	opacity: 1;
}

.last-item {
	flex-direction: column;
	justify-content: flex-start;
    align-items: flex-start;

	.note__content--label {
		margin-bottom: 6px;
	}
}
</style>
